/* prettier-ignore */

/* biome-ignore lint/all: This is an auto-generated file */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './_routes/__root'
import { Route as SteuerberaterRouteImport } from "./_routes/steuerberater";
import { Route as ScriptsRouteImport } from "./_routes/scripts";
import { Route as NutzerRouteImport } from "./_routes/nutzer";
import { Route as AngebotErstellenRouteImport } from "./_routes/angebot-erstellen";
import { Route as AbmeldenRouteImport } from "./_routes/abmelden";
import { Route as FirmenRouteRouteImport } from "./_routes/firmen/route";
import { Route as IndexRouteImport } from "./_routes/index";
import { Route as VorgaengeIndexRouteImport } from "./_routes/vorgaenge/index";
import { Route as KundenIndexRouteImport } from "./_routes/kunden/index";
import { Route as JahresabschluesseIndexRouteImport } from "./_routes/jahresabschluesse/index";
import { Route as FirmenIndexRouteImport } from "./_routes/firmen/index";
import { Route as SteuerberatungenTaxAdvisoryIdRouteImport } from "./_routes/steuerberatungen/$taxAdvisoryId";
import { Route as KundenClientIdRouteImport } from "./_routes/kunden/$clientId";
import { Route as FirmenCompanyIdRouteRouteImport } from "./_routes/firmen/$companyId/route";
import { Route as FirmenCompanyIdIndexRouteImport } from "./_routes/firmen/$companyId/index";
import { Route as FirmenCompanyIdZahlungenRouteImport } from "./_routes/firmen/$companyId/zahlungen";
import { Route as FirmenCompanyIdVorgaengeRouteImport } from "./_routes/firmen/$companyId/vorgaenge";
import { Route as FirmenCompanyIdTransaktionenRouteImport } from "./_routes/firmen/$companyId/transaktionen";
import { Route as FirmenCompanyIdTechnischRouteImport } from "./_routes/firmen/$companyId/technisch";
import { Route as FirmenCompanyIdMandantenRouteImport } from "./_routes/firmen/$companyId/mandanten";
import { Route as FirmenCompanyIdJahresabschluesseRouteImport } from "./_routes/firmen/$companyId/jahresabschluesse";
import { Route as FirmenCompanyIdBuchungenRouteImport } from "./_routes/firmen/$companyId/buchungen";
import { Route as FirmenCompanyIdAufgabenRouteImport } from "./_routes/firmen/$companyId/aufgaben";
import { Route as FirmenCompanyIdStammdatenRouteRouteImport } from "./_routes/firmen/$companyId/stammdaten/route";
import { Route as FirmenCompanyIdStammdatenIndexRouteImport } from "./_routes/firmen/$companyId/stammdaten/index";
import { Route as FirmenCompanyIdStammdatenTechtaxEintragenRouteImport } from "./_routes/firmen/$companyId/stammdaten/techtax-eintragen";
import { Route as FirmenCompanyIdStammdatenDatevEintragenRouteImport } from "./_routes/firmen/$companyId/stammdaten/datev-eintragen";
import { Route as FirmenCompanyIdDokumenteChar123DocumentIdChar125RouteImport } from "./_routes/firmen/$companyId/dokumente.{-$documentId}";
import { Route as FirmenCompanyIdJahreYearBilanzRouteImport } from "./_routes/firmen/$companyId/jahre/$year/bilanz";

const SteuerberaterRoute = SteuerberaterRouteImport.update({
  id: "/steuerberater",
  path: "/steuerberater",
  getParentRoute: () => rootRouteImport,
} as any);
const ScriptsRoute = ScriptsRouteImport.update({
  id: "/scripts",
  path: "/scripts",
  getParentRoute: () => rootRouteImport,
} as any);
const NutzerRoute = NutzerRouteImport.update({
  id: "/nutzer",
  path: "/nutzer",
  getParentRoute: () => rootRouteImport,
} as any);
const AngebotErstellenRoute = AngebotErstellenRouteImport.update({
  id: "/angebot-erstellen",
  path: "/angebot-erstellen",
  getParentRoute: () => rootRouteImport,
} as any);
const AbmeldenRoute = AbmeldenRouteImport.update({
  id: "/abmelden",
  path: "/abmelden",
  getParentRoute: () => rootRouteImport,
} as any);
const FirmenRouteRoute = FirmenRouteRouteImport.update({
  id: "/firmen",
  path: "/firmen",
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any);
const VorgaengeIndexRoute = VorgaengeIndexRouteImport.update({
  id: "/vorgaenge/",
  path: "/vorgaenge/",
  getParentRoute: () => rootRouteImport,
} as any);
const KundenIndexRoute = KundenIndexRouteImport.update({
  id: "/kunden/",
  path: "/kunden/",
  getParentRoute: () => rootRouteImport,
} as any);
const JahresabschluesseIndexRoute = JahresabschluesseIndexRouteImport.update({
  id: "/jahresabschluesse/",
  path: "/jahresabschluesse/",
  getParentRoute: () => rootRouteImport,
} as any);
const FirmenIndexRoute = FirmenIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => FirmenRouteRoute,
} as any);
const SteuerberatungenTaxAdvisoryIdRoute =
  SteuerberatungenTaxAdvisoryIdRouteImport.update({
    id: "/steuerberatungen/$taxAdvisoryId",
    path: "/steuerberatungen/$taxAdvisoryId",
    getParentRoute: () => rootRouteImport,
  } as any);
const KundenClientIdRoute = KundenClientIdRouteImport.update({
  id: "/kunden/$clientId",
  path: "/kunden/$clientId",
  getParentRoute: () => rootRouteImport,
} as any);
const FirmenCompanyIdRouteRoute = FirmenCompanyIdRouteRouteImport.update({
  id: "/$companyId",
  path: "/$companyId",
  getParentRoute: () => FirmenRouteRoute,
} as any);
const FirmenCompanyIdIndexRoute = FirmenCompanyIdIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => FirmenCompanyIdRouteRoute,
} as any);
const FirmenCompanyIdZahlungenRoute =
  FirmenCompanyIdZahlungenRouteImport.update({
    id: "/zahlungen",
    path: "/zahlungen",
    getParentRoute: () => FirmenCompanyIdRouteRoute,
  } as any);
const FirmenCompanyIdVorgaengeRoute =
  FirmenCompanyIdVorgaengeRouteImport.update({
    id: "/vorgaenge",
    path: "/vorgaenge",
    getParentRoute: () => FirmenCompanyIdRouteRoute,
  } as any);
const FirmenCompanyIdTransaktionenRoute =
  FirmenCompanyIdTransaktionenRouteImport.update({
    id: "/transaktionen",
    path: "/transaktionen",
    getParentRoute: () => FirmenCompanyIdRouteRoute,
  } as any);
const FirmenCompanyIdTechnischRoute =
  FirmenCompanyIdTechnischRouteImport.update({
    id: "/technisch",
    path: "/technisch",
    getParentRoute: () => FirmenCompanyIdRouteRoute,
  } as any);
const FirmenCompanyIdMandantenRoute =
  FirmenCompanyIdMandantenRouteImport.update({
    id: "/mandanten",
    path: "/mandanten",
    getParentRoute: () => FirmenCompanyIdRouteRoute,
  } as any);
const FirmenCompanyIdJahresabschluesseRoute =
  FirmenCompanyIdJahresabschluesseRouteImport.update({
    id: "/jahresabschluesse",
    path: "/jahresabschluesse",
    getParentRoute: () => FirmenCompanyIdRouteRoute,
  } as any);
const FirmenCompanyIdBuchungenRoute =
  FirmenCompanyIdBuchungenRouteImport.update({
    id: "/buchungen",
    path: "/buchungen",
    getParentRoute: () => FirmenCompanyIdRouteRoute,
  } as any);
const FirmenCompanyIdAufgabenRoute = FirmenCompanyIdAufgabenRouteImport.update({
  id: "/aufgaben",
  path: "/aufgaben",
  getParentRoute: () => FirmenCompanyIdRouteRoute,
} as any);
const FirmenCompanyIdStammdatenRouteRoute =
  FirmenCompanyIdStammdatenRouteRouteImport.update({
    id: "/stammdaten",
    path: "/stammdaten",
    getParentRoute: () => FirmenCompanyIdRouteRoute,
  } as any);
const FirmenCompanyIdStammdatenIndexRoute =
  FirmenCompanyIdStammdatenIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => FirmenCompanyIdStammdatenRouteRoute,
  } as any);
const FirmenCompanyIdStammdatenTechtaxEintragenRoute =
  FirmenCompanyIdStammdatenTechtaxEintragenRouteImport.update({
    id: "/techtax-eintragen",
    path: "/techtax-eintragen",
    getParentRoute: () => FirmenCompanyIdStammdatenRouteRoute,
  } as any);
const FirmenCompanyIdStammdatenDatevEintragenRoute =
  FirmenCompanyIdStammdatenDatevEintragenRouteImport.update({
    id: "/datev-eintragen",
    path: "/datev-eintragen",
    getParentRoute: () => FirmenCompanyIdStammdatenRouteRoute,
  } as any);
const FirmenCompanyIdDokumenteChar123DocumentIdChar125Route =
  FirmenCompanyIdDokumenteChar123DocumentIdChar125RouteImport.update({
    id: "/dokumente/{-$documentId}",
    path: "/dokumente/{-$documentId}",
    getParentRoute: () => FirmenCompanyIdRouteRoute,
  } as any);
const FirmenCompanyIdJahreYearBilanzRoute =
  FirmenCompanyIdJahreYearBilanzRouteImport.update({
    id: "/jahre/$year/bilanz",
    path: "/jahre/$year/bilanz",
    getParentRoute: () => FirmenCompanyIdRouteRoute,
  } as any);

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "/firmen": typeof FirmenRouteRouteWithChildren;
  "/abmelden": typeof AbmeldenRoute;
  "/angebot-erstellen": typeof AngebotErstellenRoute;
  "/nutzer": typeof NutzerRoute;
  "/scripts": typeof ScriptsRoute;
  "/steuerberater": typeof SteuerberaterRoute;
  "/firmen/$companyId": typeof FirmenCompanyIdRouteRouteWithChildren;
  "/kunden/$clientId": typeof KundenClientIdRoute;
  "/steuerberatungen/$taxAdvisoryId": typeof SteuerberatungenTaxAdvisoryIdRoute;
  "/firmen/": typeof FirmenIndexRoute;
  "/jahresabschluesse/": typeof JahresabschluesseIndexRoute;
  "/kunden/": typeof KundenIndexRoute;
  "/vorgaenge/": typeof VorgaengeIndexRoute;
  "/firmen/$companyId/stammdaten": typeof FirmenCompanyIdStammdatenRouteRouteWithChildren;
  "/firmen/$companyId/aufgaben": typeof FirmenCompanyIdAufgabenRoute;
  "/firmen/$companyId/buchungen": typeof FirmenCompanyIdBuchungenRoute;
  "/firmen/$companyId/jahresabschluesse": typeof FirmenCompanyIdJahresabschluesseRoute;
  "/firmen/$companyId/mandanten": typeof FirmenCompanyIdMandantenRoute;
  "/firmen/$companyId/technisch": typeof FirmenCompanyIdTechnischRoute;
  "/firmen/$companyId/transaktionen": typeof FirmenCompanyIdTransaktionenRoute;
  "/firmen/$companyId/vorgaenge": typeof FirmenCompanyIdVorgaengeRoute;
  "/firmen/$companyId/zahlungen": typeof FirmenCompanyIdZahlungenRoute;
  "/firmen/$companyId/": typeof FirmenCompanyIdIndexRoute;
  "/firmen/$companyId/dokumente/{-$documentId}": typeof FirmenCompanyIdDokumenteChar123DocumentIdChar125Route;
  "/firmen/$companyId/stammdaten/datev-eintragen": typeof FirmenCompanyIdStammdatenDatevEintragenRoute;
  "/firmen/$companyId/stammdaten/techtax-eintragen": typeof FirmenCompanyIdStammdatenTechtaxEintragenRoute;
  "/firmen/$companyId/stammdaten/": typeof FirmenCompanyIdStammdatenIndexRoute;
  "/firmen/$companyId/jahre/$year/bilanz": typeof FirmenCompanyIdJahreYearBilanzRoute;
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "/abmelden": typeof AbmeldenRoute;
  "/angebot-erstellen": typeof AngebotErstellenRoute;
  "/nutzer": typeof NutzerRoute;
  "/scripts": typeof ScriptsRoute;
  "/steuerberater": typeof SteuerberaterRoute;
  "/kunden/$clientId": typeof KundenClientIdRoute;
  "/steuerberatungen/$taxAdvisoryId": typeof SteuerberatungenTaxAdvisoryIdRoute;
  "/firmen": typeof FirmenIndexRoute;
  "/jahresabschluesse": typeof JahresabschluesseIndexRoute;
  "/kunden": typeof KundenIndexRoute;
  "/vorgaenge": typeof VorgaengeIndexRoute;
  "/firmen/$companyId/aufgaben": typeof FirmenCompanyIdAufgabenRoute;
  "/firmen/$companyId/buchungen": typeof FirmenCompanyIdBuchungenRoute;
  "/firmen/$companyId/jahresabschluesse": typeof FirmenCompanyIdJahresabschluesseRoute;
  "/firmen/$companyId/mandanten": typeof FirmenCompanyIdMandantenRoute;
  "/firmen/$companyId/technisch": typeof FirmenCompanyIdTechnischRoute;
  "/firmen/$companyId/transaktionen": typeof FirmenCompanyIdTransaktionenRoute;
  "/firmen/$companyId/vorgaenge": typeof FirmenCompanyIdVorgaengeRoute;
  "/firmen/$companyId/zahlungen": typeof FirmenCompanyIdZahlungenRoute;
  "/firmen/$companyId": typeof FirmenCompanyIdIndexRoute;
  "/firmen/$companyId/dokumente/{-$documentId}": typeof FirmenCompanyIdDokumenteChar123DocumentIdChar125Route;
  "/firmen/$companyId/stammdaten/datev-eintragen": typeof FirmenCompanyIdStammdatenDatevEintragenRoute;
  "/firmen/$companyId/stammdaten/techtax-eintragen": typeof FirmenCompanyIdStammdatenTechtaxEintragenRoute;
  "/firmen/$companyId/stammdaten": typeof FirmenCompanyIdStammdatenIndexRoute;
  "/firmen/$companyId/jahre/$year/bilanz": typeof FirmenCompanyIdJahreYearBilanzRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/": typeof IndexRoute;
  "/firmen": typeof FirmenRouteRouteWithChildren;
  "/abmelden": typeof AbmeldenRoute;
  "/angebot-erstellen": typeof AngebotErstellenRoute;
  "/nutzer": typeof NutzerRoute;
  "/scripts": typeof ScriptsRoute;
  "/steuerberater": typeof SteuerberaterRoute;
  "/firmen/$companyId": typeof FirmenCompanyIdRouteRouteWithChildren;
  "/kunden/$clientId": typeof KundenClientIdRoute;
  "/steuerberatungen/$taxAdvisoryId": typeof SteuerberatungenTaxAdvisoryIdRoute;
  "/firmen/": typeof FirmenIndexRoute;
  "/jahresabschluesse/": typeof JahresabschluesseIndexRoute;
  "/kunden/": typeof KundenIndexRoute;
  "/vorgaenge/": typeof VorgaengeIndexRoute;
  "/firmen/$companyId/stammdaten": typeof FirmenCompanyIdStammdatenRouteRouteWithChildren;
  "/firmen/$companyId/aufgaben": typeof FirmenCompanyIdAufgabenRoute;
  "/firmen/$companyId/buchungen": typeof FirmenCompanyIdBuchungenRoute;
  "/firmen/$companyId/jahresabschluesse": typeof FirmenCompanyIdJahresabschluesseRoute;
  "/firmen/$companyId/mandanten": typeof FirmenCompanyIdMandantenRoute;
  "/firmen/$companyId/technisch": typeof FirmenCompanyIdTechnischRoute;
  "/firmen/$companyId/transaktionen": typeof FirmenCompanyIdTransaktionenRoute;
  "/firmen/$companyId/vorgaenge": typeof FirmenCompanyIdVorgaengeRoute;
  "/firmen/$companyId/zahlungen": typeof FirmenCompanyIdZahlungenRoute;
  "/firmen/$companyId/": typeof FirmenCompanyIdIndexRoute;
  "/firmen/$companyId/dokumente/{-$documentId}": typeof FirmenCompanyIdDokumenteChar123DocumentIdChar125Route;
  "/firmen/$companyId/stammdaten/datev-eintragen": typeof FirmenCompanyIdStammdatenDatevEintragenRoute;
  "/firmen/$companyId/stammdaten/techtax-eintragen": typeof FirmenCompanyIdStammdatenTechtaxEintragenRoute;
  "/firmen/$companyId/stammdaten/": typeof FirmenCompanyIdStammdatenIndexRoute;
  "/firmen/$companyId/jahre/$year/bilanz": typeof FirmenCompanyIdJahreYearBilanzRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/firmen"
    | "/abmelden"
    | "/angebot-erstellen"
    | "/nutzer"
    | "/scripts"
    | "/steuerberater"
    | "/firmen/$companyId"
    | "/kunden/$clientId"
    | "/steuerberatungen/$taxAdvisoryId"
    | "/firmen/"
    | "/jahresabschluesse/"
    | "/kunden/"
    | "/vorgaenge/"
    | "/firmen/$companyId/stammdaten"
    | "/firmen/$companyId/aufgaben"
    | "/firmen/$companyId/buchungen"
    | "/firmen/$companyId/jahresabschluesse"
    | "/firmen/$companyId/mandanten"
    | "/firmen/$companyId/technisch"
    | "/firmen/$companyId/transaktionen"
    | "/firmen/$companyId/vorgaenge"
    | "/firmen/$companyId/zahlungen"
    | "/firmen/$companyId/"
    | "/firmen/$companyId/dokumente/{-$documentId}"
    | "/firmen/$companyId/stammdaten/datev-eintragen"
    | "/firmen/$companyId/stammdaten/techtax-eintragen"
    | "/firmen/$companyId/stammdaten/"
    | "/firmen/$companyId/jahre/$year/bilanz";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/abmelden"
    | "/angebot-erstellen"
    | "/nutzer"
    | "/scripts"
    | "/steuerberater"
    | "/kunden/$clientId"
    | "/steuerberatungen/$taxAdvisoryId"
    | "/firmen"
    | "/jahresabschluesse"
    | "/kunden"
    | "/vorgaenge"
    | "/firmen/$companyId/aufgaben"
    | "/firmen/$companyId/buchungen"
    | "/firmen/$companyId/jahresabschluesse"
    | "/firmen/$companyId/mandanten"
    | "/firmen/$companyId/technisch"
    | "/firmen/$companyId/transaktionen"
    | "/firmen/$companyId/vorgaenge"
    | "/firmen/$companyId/zahlungen"
    | "/firmen/$companyId"
    | "/firmen/$companyId/dokumente/{-$documentId}"
    | "/firmen/$companyId/stammdaten/datev-eintragen"
    | "/firmen/$companyId/stammdaten/techtax-eintragen"
    | "/firmen/$companyId/stammdaten"
    | "/firmen/$companyId/jahre/$year/bilanz";
  id:
    | "__root__"
    | "/"
    | "/firmen"
    | "/abmelden"
    | "/angebot-erstellen"
    | "/nutzer"
    | "/scripts"
    | "/steuerberater"
    | "/firmen/$companyId"
    | "/kunden/$clientId"
    | "/steuerberatungen/$taxAdvisoryId"
    | "/firmen/"
    | "/jahresabschluesse/"
    | "/kunden/"
    | "/vorgaenge/"
    | "/firmen/$companyId/stammdaten"
    | "/firmen/$companyId/aufgaben"
    | "/firmen/$companyId/buchungen"
    | "/firmen/$companyId/jahresabschluesse"
    | "/firmen/$companyId/mandanten"
    | "/firmen/$companyId/technisch"
    | "/firmen/$companyId/transaktionen"
    | "/firmen/$companyId/vorgaenge"
    | "/firmen/$companyId/zahlungen"
    | "/firmen/$companyId/"
    | "/firmen/$companyId/dokumente/{-$documentId}"
    | "/firmen/$companyId/stammdaten/datev-eintragen"
    | "/firmen/$companyId/stammdaten/techtax-eintragen"
    | "/firmen/$companyId/stammdaten/"
    | "/firmen/$companyId/jahre/$year/bilanz";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  FirmenRouteRoute: typeof FirmenRouteRouteWithChildren;
  AbmeldenRoute: typeof AbmeldenRoute;
  AngebotErstellenRoute: typeof AngebotErstellenRoute;
  NutzerRoute: typeof NutzerRoute;
  ScriptsRoute: typeof ScriptsRoute;
  SteuerberaterRoute: typeof SteuerberaterRoute;
  KundenClientIdRoute: typeof KundenClientIdRoute;
  SteuerberatungenTaxAdvisoryIdRoute: typeof SteuerberatungenTaxAdvisoryIdRoute;
  JahresabschluesseIndexRoute: typeof JahresabschluesseIndexRoute;
  KundenIndexRoute: typeof KundenIndexRoute;
  VorgaengeIndexRoute: typeof VorgaengeIndexRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/steuerberater": {
      id: "/steuerberater";
      path: "/steuerberater";
      fullPath: "/steuerberater";
      preLoaderRoute: typeof SteuerberaterRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/scripts": {
      id: "/scripts";
      path: "/scripts";
      fullPath: "/scripts";
      preLoaderRoute: typeof ScriptsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/nutzer": {
      id: "/nutzer";
      path: "/nutzer";
      fullPath: "/nutzer";
      preLoaderRoute: typeof NutzerRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/angebot-erstellen": {
      id: "/angebot-erstellen";
      path: "/angebot-erstellen";
      fullPath: "/angebot-erstellen";
      preLoaderRoute: typeof AngebotErstellenRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/abmelden": {
      id: "/abmelden";
      path: "/abmelden";
      fullPath: "/abmelden";
      preLoaderRoute: typeof AbmeldenRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/firmen": {
      id: "/firmen";
      path: "/firmen";
      fullPath: "/firmen";
      preLoaderRoute: typeof FirmenRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/vorgaenge/": {
      id: "/vorgaenge/";
      path: "/vorgaenge";
      fullPath: "/vorgaenge/";
      preLoaderRoute: typeof VorgaengeIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/kunden/": {
      id: "/kunden/";
      path: "/kunden";
      fullPath: "/kunden/";
      preLoaderRoute: typeof KundenIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/jahresabschluesse/": {
      id: "/jahresabschluesse/";
      path: "/jahresabschluesse";
      fullPath: "/jahresabschluesse/";
      preLoaderRoute: typeof JahresabschluesseIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/firmen/": {
      id: "/firmen/";
      path: "/";
      fullPath: "/firmen/";
      preLoaderRoute: typeof FirmenIndexRouteImport;
      parentRoute: typeof FirmenRouteRoute;
    };
    "/steuerberatungen/$taxAdvisoryId": {
      id: "/steuerberatungen/$taxAdvisoryId";
      path: "/steuerberatungen/$taxAdvisoryId";
      fullPath: "/steuerberatungen/$taxAdvisoryId";
      preLoaderRoute: typeof SteuerberatungenTaxAdvisoryIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/kunden/$clientId": {
      id: "/kunden/$clientId";
      path: "/kunden/$clientId";
      fullPath: "/kunden/$clientId";
      preLoaderRoute: typeof KundenClientIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/firmen/$companyId": {
      id: "/firmen/$companyId";
      path: "/$companyId";
      fullPath: "/firmen/$companyId";
      preLoaderRoute: typeof FirmenCompanyIdRouteRouteImport;
      parentRoute: typeof FirmenRouteRoute;
    };
    "/firmen/$companyId/": {
      id: "/firmen/$companyId/";
      path: "/";
      fullPath: "/firmen/$companyId/";
      preLoaderRoute: typeof FirmenCompanyIdIndexRouteImport;
      parentRoute: typeof FirmenCompanyIdRouteRoute;
    };
    "/firmen/$companyId/zahlungen": {
      id: "/firmen/$companyId/zahlungen";
      path: "/zahlungen";
      fullPath: "/firmen/$companyId/zahlungen";
      preLoaderRoute: typeof FirmenCompanyIdZahlungenRouteImport;
      parentRoute: typeof FirmenCompanyIdRouteRoute;
    };
    "/firmen/$companyId/vorgaenge": {
      id: "/firmen/$companyId/vorgaenge";
      path: "/vorgaenge";
      fullPath: "/firmen/$companyId/vorgaenge";
      preLoaderRoute: typeof FirmenCompanyIdVorgaengeRouteImport;
      parentRoute: typeof FirmenCompanyIdRouteRoute;
    };
    "/firmen/$companyId/transaktionen": {
      id: "/firmen/$companyId/transaktionen";
      path: "/transaktionen";
      fullPath: "/firmen/$companyId/transaktionen";
      preLoaderRoute: typeof FirmenCompanyIdTransaktionenRouteImport;
      parentRoute: typeof FirmenCompanyIdRouteRoute;
    };
    "/firmen/$companyId/technisch": {
      id: "/firmen/$companyId/technisch";
      path: "/technisch";
      fullPath: "/firmen/$companyId/technisch";
      preLoaderRoute: typeof FirmenCompanyIdTechnischRouteImport;
      parentRoute: typeof FirmenCompanyIdRouteRoute;
    };
    "/firmen/$companyId/mandanten": {
      id: "/firmen/$companyId/mandanten";
      path: "/mandanten";
      fullPath: "/firmen/$companyId/mandanten";
      preLoaderRoute: typeof FirmenCompanyIdMandantenRouteImport;
      parentRoute: typeof FirmenCompanyIdRouteRoute;
    };
    "/firmen/$companyId/jahresabschluesse": {
      id: "/firmen/$companyId/jahresabschluesse";
      path: "/jahresabschluesse";
      fullPath: "/firmen/$companyId/jahresabschluesse";
      preLoaderRoute: typeof FirmenCompanyIdJahresabschluesseRouteImport;
      parentRoute: typeof FirmenCompanyIdRouteRoute;
    };
    "/firmen/$companyId/buchungen": {
      id: "/firmen/$companyId/buchungen";
      path: "/buchungen";
      fullPath: "/firmen/$companyId/buchungen";
      preLoaderRoute: typeof FirmenCompanyIdBuchungenRouteImport;
      parentRoute: typeof FirmenCompanyIdRouteRoute;
    };
    "/firmen/$companyId/aufgaben": {
      id: "/firmen/$companyId/aufgaben";
      path: "/aufgaben";
      fullPath: "/firmen/$companyId/aufgaben";
      preLoaderRoute: typeof FirmenCompanyIdAufgabenRouteImport;
      parentRoute: typeof FirmenCompanyIdRouteRoute;
    };
    "/firmen/$companyId/stammdaten": {
      id: "/firmen/$companyId/stammdaten";
      path: "/stammdaten";
      fullPath: "/firmen/$companyId/stammdaten";
      preLoaderRoute: typeof FirmenCompanyIdStammdatenRouteRouteImport;
      parentRoute: typeof FirmenCompanyIdRouteRoute;
    };
    "/firmen/$companyId/stammdaten/": {
      id: "/firmen/$companyId/stammdaten/";
      path: "/";
      fullPath: "/firmen/$companyId/stammdaten/";
      preLoaderRoute: typeof FirmenCompanyIdStammdatenIndexRouteImport;
      parentRoute: typeof FirmenCompanyIdStammdatenRouteRoute;
    };
    "/firmen/$companyId/stammdaten/techtax-eintragen": {
      id: "/firmen/$companyId/stammdaten/techtax-eintragen";
      path: "/techtax-eintragen";
      fullPath: "/firmen/$companyId/stammdaten/techtax-eintragen";
      preLoaderRoute: typeof FirmenCompanyIdStammdatenTechtaxEintragenRouteImport;
      parentRoute: typeof FirmenCompanyIdStammdatenRouteRoute;
    };
    "/firmen/$companyId/stammdaten/datev-eintragen": {
      id: "/firmen/$companyId/stammdaten/datev-eintragen";
      path: "/datev-eintragen";
      fullPath: "/firmen/$companyId/stammdaten/datev-eintragen";
      preLoaderRoute: typeof FirmenCompanyIdStammdatenDatevEintragenRouteImport;
      parentRoute: typeof FirmenCompanyIdStammdatenRouteRoute;
    };
    "/firmen/$companyId/dokumente/{-$documentId}": {
      id: "/firmen/$companyId/dokumente/{-$documentId}";
      path: "/dokumente/{-$documentId}";
      fullPath: "/firmen/$companyId/dokumente/{-$documentId}";
      preLoaderRoute: typeof FirmenCompanyIdDokumenteChar123DocumentIdChar125RouteImport;
      parentRoute: typeof FirmenCompanyIdRouteRoute;
    };
    "/firmen/$companyId/jahre/$year/bilanz": {
      id: "/firmen/$companyId/jahre/$year/bilanz";
      path: "/jahre/$year/bilanz";
      fullPath: "/firmen/$companyId/jahre/$year/bilanz";
      preLoaderRoute: typeof FirmenCompanyIdJahreYearBilanzRouteImport;
      parentRoute: typeof FirmenCompanyIdRouteRoute;
    };
  }
}

interface FirmenCompanyIdStammdatenRouteRouteChildren {
  FirmenCompanyIdStammdatenDatevEintragenRoute: typeof FirmenCompanyIdStammdatenDatevEintragenRoute;
  FirmenCompanyIdStammdatenTechtaxEintragenRoute: typeof FirmenCompanyIdStammdatenTechtaxEintragenRoute;
  FirmenCompanyIdStammdatenIndexRoute: typeof FirmenCompanyIdStammdatenIndexRoute;
}

const FirmenCompanyIdStammdatenRouteRouteChildren: FirmenCompanyIdStammdatenRouteRouteChildren =
  {
    FirmenCompanyIdStammdatenDatevEintragenRoute:
      FirmenCompanyIdStammdatenDatevEintragenRoute,
    FirmenCompanyIdStammdatenTechtaxEintragenRoute:
      FirmenCompanyIdStammdatenTechtaxEintragenRoute,
    FirmenCompanyIdStammdatenIndexRoute: FirmenCompanyIdStammdatenIndexRoute,
  };

const FirmenCompanyIdStammdatenRouteRouteWithChildren =
  FirmenCompanyIdStammdatenRouteRoute._addFileChildren(
    FirmenCompanyIdStammdatenRouteRouteChildren,
  );

interface FirmenCompanyIdRouteRouteChildren {
  FirmenCompanyIdStammdatenRouteRoute: typeof FirmenCompanyIdStammdatenRouteRouteWithChildren;
  FirmenCompanyIdAufgabenRoute: typeof FirmenCompanyIdAufgabenRoute;
  FirmenCompanyIdBuchungenRoute: typeof FirmenCompanyIdBuchungenRoute;
  FirmenCompanyIdJahresabschluesseRoute: typeof FirmenCompanyIdJahresabschluesseRoute;
  FirmenCompanyIdMandantenRoute: typeof FirmenCompanyIdMandantenRoute;
  FirmenCompanyIdTechnischRoute: typeof FirmenCompanyIdTechnischRoute;
  FirmenCompanyIdTransaktionenRoute: typeof FirmenCompanyIdTransaktionenRoute;
  FirmenCompanyIdVorgaengeRoute: typeof FirmenCompanyIdVorgaengeRoute;
  FirmenCompanyIdZahlungenRoute: typeof FirmenCompanyIdZahlungenRoute;
  FirmenCompanyIdIndexRoute: typeof FirmenCompanyIdIndexRoute;
  FirmenCompanyIdDokumenteChar123DocumentIdChar125Route: typeof FirmenCompanyIdDokumenteChar123DocumentIdChar125Route;
  FirmenCompanyIdJahreYearBilanzRoute: typeof FirmenCompanyIdJahreYearBilanzRoute;
}

const FirmenCompanyIdRouteRouteChildren: FirmenCompanyIdRouteRouteChildren = {
  FirmenCompanyIdStammdatenRouteRoute:
    FirmenCompanyIdStammdatenRouteRouteWithChildren,
  FirmenCompanyIdAufgabenRoute: FirmenCompanyIdAufgabenRoute,
  FirmenCompanyIdBuchungenRoute: FirmenCompanyIdBuchungenRoute,
  FirmenCompanyIdJahresabschluesseRoute: FirmenCompanyIdJahresabschluesseRoute,
  FirmenCompanyIdMandantenRoute: FirmenCompanyIdMandantenRoute,
  FirmenCompanyIdTechnischRoute: FirmenCompanyIdTechnischRoute,
  FirmenCompanyIdTransaktionenRoute: FirmenCompanyIdTransaktionenRoute,
  FirmenCompanyIdVorgaengeRoute: FirmenCompanyIdVorgaengeRoute,
  FirmenCompanyIdZahlungenRoute: FirmenCompanyIdZahlungenRoute,
  FirmenCompanyIdIndexRoute: FirmenCompanyIdIndexRoute,
  FirmenCompanyIdDokumenteChar123DocumentIdChar125Route:
    FirmenCompanyIdDokumenteChar123DocumentIdChar125Route,
  FirmenCompanyIdJahreYearBilanzRoute: FirmenCompanyIdJahreYearBilanzRoute,
};

const FirmenCompanyIdRouteRouteWithChildren =
  FirmenCompanyIdRouteRoute._addFileChildren(FirmenCompanyIdRouteRouteChildren);

interface FirmenRouteRouteChildren {
  FirmenCompanyIdRouteRoute: typeof FirmenCompanyIdRouteRouteWithChildren;
  FirmenIndexRoute: typeof FirmenIndexRoute;
}

const FirmenRouteRouteChildren: FirmenRouteRouteChildren = {
  FirmenCompanyIdRouteRoute: FirmenCompanyIdRouteRouteWithChildren,
  FirmenIndexRoute: FirmenIndexRoute,
};

const FirmenRouteRouteWithChildren = FirmenRouteRoute._addFileChildren(
  FirmenRouteRouteChildren,
);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  FirmenRouteRoute: FirmenRouteRouteWithChildren,
  AbmeldenRoute: AbmeldenRoute,
  AngebotErstellenRoute: AngebotErstellenRoute,
  NutzerRoute: NutzerRoute,
  ScriptsRoute: ScriptsRoute,
  SteuerberaterRoute: SteuerberaterRoute,
  KundenClientIdRoute: KundenClientIdRoute,
  SteuerberatungenTaxAdvisoryIdRoute: SteuerberatungenTaxAdvisoryIdRoute,
  JahresabschluesseIndexRoute: JahresabschluesseIndexRoute,
  KundenIndexRoute: KundenIndexRoute,
  VorgaengeIndexRoute: VorgaengeIndexRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
